// extracted by mini-css-extract-plugin
module.exports = {"CorgiSwim":"CorgiSwim_CorgiSwim__3a94p","flood":"CorgiSwim_flood__fccc6","swim":"CorgiSwim_swim__Yolnl"};